import algoliaApi from '../services/algolia-api';

export const NETWORK_REQUEST = 'NETWORK_REQUEST';
export const NETWORK_SUCCESS = 'NETWORK_SUCCESS';
export const NETWORK_ERROR = 'NETWORK_ERROR';

const requestNetwork = networkId => ({
  type: NETWORK_REQUEST,
  networkId
});

export const loadNetwork = fetchedNetwork => ({
  type: NETWORK_SUCCESS,
  fetchedNetwork
});

const errorNetwork = error => ({
  type: NETWORK_ERROR,
  error
});

export const getNetworkData = networkId => async dispatch => {
  dispatch(requestNetwork(networkId));

  try {
    const network = await algoliaApi.getNetworkData(networkId);

    dispatch(loadNetwork(network));
  } catch (err) {
    dispatch(errorNetwork(err));
  }
};
